import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Vendor } from 'src/app/shared/models/database-models';

@Component({
  selector: 'app-input-justification',
  templateUrl: './input-justification.component.html',
  styleUrls: ['./input-justification.component.scss'],
})
export class InputJustificationComponent implements OnInit, OnChanges {
  @Input() vendor!: Vendor;
  @Input() Justification: string = '';
  @Input() isError?: boolean;
  @Input() isEdit?: boolean;

  justificationControl: string = '';
  constructor() {}

  ngOnInit(): void {
    this.justificationControl = this.Justification;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['Justification'] &&
      changes['Justification'].currentValue !== this.justificationControl
    ) {
      this.justificationControl = changes['Justification'].currentValue;
    }
  }

  justificationChange(event: any) {
    this.vendor.Justification = event.target.value;
  }
}
